import { Button } from '@mui/material';
import React from 'react';
import Error from './Error';

const NetworkErrorComponent = () => {
  return (
    <Error
      title={{ key: 'pages:errorBoundary.networkError' }}
      message={(t) => t('pages:errorBoundary.networkErrorExplanation')}
      exit={(t) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
        >
          {t('pages:errorBoundary.reload')}
        </Button>
      )}
    />
  );
};

export default NetworkErrorComponent;
